import * as couponVoteTypes from "../types/couponVoteTypes";
import * as couponVoteServices from "../../services/couponVoteServices";
import { mergeCoupon } from "./couponActions";

export const upsertCouponVote = (couponPublicId, value) => async (dispatch) => {
  dispatch({
    type: couponVoteTypes.COUPON_VOTE_UPSERT_REQUEST,
    payload: { couponPublicId },
  });
  try {
    const data = await couponVoteServices.upsertCouponVote(
      couponPublicId,
      value
    );
    dispatch({
      type: couponVoteTypes.COUPON_VOTE_UPSERT_SUCCESS,
      payload: { couponPublicId, data },
    });
    if (data?.coupon) dispatch(mergeCoupon(data.coupon));
  } catch (e) {
    dispatch({
      type: couponVoteTypes.COUPON_VOTE_UPSERT_FAILURE,
      payload:
        e?.response?.data?.message ||
        e?.message ||
        "Could not update vote",
    });
  }
};

export const removeCouponVote = (couponPublicId) => async (dispatch) => {
  dispatch({
    type: couponVoteTypes.COUPON_VOTE_REMOVE_REQUEST,
    payload: { couponPublicId },
  });
  try {
    const data = await couponVoteServices.removeCouponVote(couponPublicId);
    dispatch({
      type: couponVoteTypes.COUPON_VOTE_REMOVE_SUCCESS,
      payload: { couponPublicId, data },
    });
    if (data?.coupon) dispatch(mergeCoupon(data.coupon));
  } catch (e) {
    dispatch({
      type: couponVoteTypes.COUPON_VOTE_REMOVE_FAILURE,
      payload:
        e?.response?.data?.message ||
        e?.message ||
        "Could not remove vote",
    });
  }
};
